export default __webpack_public_path__ + "static/media/egalitarian-2.8b984687.jpg";